const DEBUG = process.env.NODE_ENV === 'development';

export const logDebug = (...args) => {
  if (DEBUG) {
    console.log(...args);
  }
};

export const logError = (...args) => {
  console.error(...args);
};

export const logAttempt = (algorithmId, mode, time, additionalInfo = {}) => {
  if (DEBUG) {
    console.log('Recording Algorithm Attempt:', {
      algorithmId,
      mode,
      time,
      ...additionalInfo,
      timestamp: new Date().toISOString()
    });
  }
}; 